import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef  } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'vq-submit-button',
  templateUrl: './submit-button.component.html',
  styles: []
})
export class SubmitButtonComponent implements OnInit {

	@Input() label: string;
	@Input() isLoading: boolean;
	@Input('vqClassList') classlist:Array<string> = [];

	@Output() onClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onclickbutton(event) {
    this.onClick.emit(event);
  }

}



// WEBPACK FOOTER //
// ./src/app/vqforms/submit-button/submit-button.component.ts